import React, { FunctionComponent } from 'react';
import ConfirmationDialog from '../../../../../eliot-components/src/ConfirmationDialog/ConfirmationDialog';
import { useConfig } from '../../../../../eliot-components/src/ConfigProvider/hooks';
import { useDeleteOrgMutation } from '../../../../../store/api-slice';
import { parseErrorMessage } from '../../../../../eliot-components/src/utils/helpers';
import { useSnackbar } from 'notistack';

interface Props {
  onCreated?(): void;
  onClose(): void;
  isOpen: boolean;
  orgId: string;
}

const DeleteOrgDialog: FunctionComponent<Props> = ({
  isOpen,
  onCreated,
  onClose,
  orgId,
}) => {
  const { apiBaseURL } = useConfig();
  const [removeOrg, { isLoading }] = useDeleteOrgMutation();
  const { enqueueSnackbar } = useSnackbar();

  return (
    <>
      <ConfirmationDialog
        questionText="Are you sure you want remove organization?"
        confirmationText="Remove"
        cancelText="Cancel"
        title="Remove Organization"
        isLoading={isLoading}
        onConfirm={() => {
          if (onCreated) {
            removeOrg({ apiBaseURL, id: orgId }).then((resp: any) => {
              if (!resp.error) {
                onCreated();
                return;
              }
              enqueueSnackbar(parseErrorMessage(resp.error), {
                variant: 'error',
              });
            });
            return;
          }
          onClose();
        }}
        onClose={(isConfirmed) => {
          if (!isConfirmed) {
            onClose();
          }
        }}
        isOpen={isOpen}
      />
    </>
  );
};

export default DeleteOrgDialog;
